<template>
  <div>
    <div class="text-center mb-8">
      <h2 class="text-h5 font-weight-bold">
        {{ $t('subscriptions.oneTimePacks') }}
      </h2>
      <p class="text--secondary mt-2 mb-0">
        {{ $t('subscriptions.oneTimeSubtitle') }}
      </p>
    </div>
    <v-row justify="center">
      <v-col
        v-for="pack of packages"
        :key="pack.id"
        cols="12"
        sm="6"
        md="3"
        class="d-flex"
      >
        <v-card
          class="pack-card d-flex flex-column text-center pa-5 flex-grow-1"
          outlined
        >
          <div class="text-h4 font-weight-bold primary--text">
            {{ pack.transform_quantity && pack.transform_quantity.divide_by }}×
          </div>
          <div class="subtitle-2 text--secondary mb-4">
            {{ $t('subscriptions.inspiration') }}
          </div>
          <div class="text-h6 font-weight-bold mb-6">
            {{ (pack.unit_amount / 100).toFixed(2) }}
            {{ pack.currency.toUpperCase() }}
          </div>
          <v-spacer />
          <v-btn
            block
            color="primary"
            outlined
            class="text-none"
            :loading="loadingId === pack.id"
            :disabled="loadingId !== '' && loadingId !== pack.id"
            @click="checkoutPack(pack.id)"
          >
            {{ $t('subscriptions.buy') }}
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
    import Vue, {PropType} from "vue";
    import {Stripe} from "@/plugins/Stripe";
    import {captureException} from "@/plugins/Sentry";
    import {StripePrice} from "@/model/Stripe";
    import { Toast } from "@/model/Toast";

    export default Vue.extend({
        name: "OneTimePacks",
        props: {
            packages: {
                type: Array as PropType<Array<StripePrice>>,
                default: () => []
            }
        },
        data: () => ({
            loadingId: ''
        }),
        methods: {
            checkoutPack: function (packId: string): void {
                this.loadingId = packId;
                Stripe.createStripeCheckoutSession(packId, this.$store.getters.user.uid, true)
                    .then(stripeCheckoutUrl => {
                        this.loadingId = '';
                        window.location.assign(stripeCheckoutUrl);
                    }).catch(error => {
                        this.$store.dispatch('toasts/add', {
                            type: 'error',
                            title: 'stripeError.title',
                        } as Toast);
                        captureException(error);
                        this.loadingId = '';
                    });
            }
        }
    });
</script>

<style lang="sass" scoped>
.pack-card
    border-radius: 16px !important
</style>
